import FigmaBlocksOutlineIcon from './FigmaBlocksOutlineIcon';

interface Properties {
  width?: number;
  height?: number;
}

/**
 * Active (selected) nav-tab state: exported Figma asset (block-nav.svg —
 * white fill, purple stroke). Pairs with `BlocksIcon`.
 */
const BlocksIconActive = ({ width = 16, height = 16 }: Properties) => {
  return <FigmaBlocksOutlineIcon width={width} height={height} />;
};

export default BlocksIconActive;
